import React, { useEffect } from 'react';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAverageWeightsData, clearMessage } from '../../../redux/slices/customer/weightTrackerSlice';

const PreviousWeeksAverageWeights = () => {
  const dispatch = useDispatch();
  const { averageWeightsData: weeklyAverages, loading, errorMessage } = useSelector((state) => state.weightTracker);

  useEffect(() => {
    dispatch(clearMessage());
  }, []); 
  
  useEffect(() => {
    dispatch(fetchAverageWeightsData());
  }, [dispatch]);

  return (
    <Layout>
      <main className="main">
        <header className="main-head flex justify-between align-center">
          <h1 className="greet-user-text">Previous Weight Averages</h1>
          <div className="ms-auto">
            <Back />
          </div>
        </header>
        <div className="page-subheading pb-3">
          <h4>Below are the weight averages you have recorded in past.</h4>
        </div>
        <div className="main-content flex justify-between flex-col-rev-mob">
          <div className="card responsive-table-container p-0 container">
            <table className="admin-table current-ingredients-table">
              <thead>
                <tr>
                  <th>Week</th>
                  <th>Average Weight</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="2" className="text-center">Loading...</td>
                  </tr>
                ) : errorMessage ? (
                  <tr>
                    <td colSpan="2" className="text-center text-danger">{errorMessage}</td>
                  </tr>
                ) : (
                  weeklyAverages && weeklyAverages.map((weekData, index) => (
                    <tr key={index}>
                      <td>{weekData.week}</td>
                      <td>{weekData.avg}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default PreviousWeeksAverageWeights;